import React from 'react'
import {
  Dialog,
  Divider,
  Grid,
  Typography,
  Tooltip,
  IconButton,
  makeStyles
} from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import CloseIcon from '@material-ui/icons/Close'

import { useLiterals } from '~/components/Literals'
import useViewportSizes from '~/components/useViewportSize'
import AppBar from '../PositionDialog/AppBar'

const useStyles = makeStyles({
  item: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 0'
  }
})

export function StoreDialogPeriod({ isOpen, setIsOpen, store, weekdaysPeriod }) {
  const theme = useTheme()
  const viewport = useViewportSizes()
  const classes = useStyles()
  const { getLiteral } = useLiterals()

  const mappedWeekdays = weekdaysPeriod.map((weekday) => weekday.split(',').map((i) => i.trim()))
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const handleClose = () => setIsOpen(false)

  return (
    <Dialog fullWidth fullScreen={isMobile} maxWidth="xs" onClose={handleClose} open={isOpen}>
      {isMobile && <AppBar title={store?.name} titleAlign="left" onClose={handleClose} />}
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 16
        }}
      >
        <Typography style={{ fontWeight: 500 }}>Horários</Typography>
        {!isMobile && (
          <Tooltip title={getLiteral('1251')} placement="bottom">
            <IconButton aria-label={getLiteral('1251')} size="small" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
      </Grid>

      <Divider style={{ width: '100%' }} />

      <Grid style={{ padding: '0 16px' }}>
        {mappedWeekdays.map(([day, time]) => (
          <Grid key={day} className={classes.item}>
            <Typography>{day}</Typography>
            <Typography>{time}</Typography>
          </Grid>
        ))}
      </Grid>
    </Dialog>
  )
}
